import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';

import { Segment, Grid, Image, Input } from 'semantic-ui-react';
import { Checkbox, FormControlLabel, Tooltip, IconButton } from 'material-ui';

import { DeclareList, Button, DeclareExamFilter } from 'components';
import { CtDeclareHeader } from 'containers';

import styles from './Declare.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

class DeclareContent extends Component {
  constructor(props) {
    super(props);
  }

  // 훈련 결과 입력
  onSearchChange = e => {
    const { takeSearchValue } = this.props;
    takeSearchValue(e.target.value);
  };

  render() {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      selectDeclareTargetNo,
      selectedTag,
      tagDataByTagNo,
      declareOrdering,
      declareDataByTargetNo,
      declareParam,
      isLoading,
      page,
      totalPages,
      totalDeclare,
      declareScrollData,
      onGetDeclare,
      onGetDeclareMail,
      onSortDeclare,
      onSortOrdering,
      onSearchDeclare,
      onRefScroll,
      getFilterParam,
      filterLength,
      currentPath,
      handleSelectOptions
    } = this.props;
    // 선택 이벤트
    const { handleSelectDeclare } = this.props;
    // 필터
    const {
      searchText,
      declareFilter,
      onFilterExamInfo,
      onFilterDivision,
      onFilterPosition,
      onFilterCancel,
      searchTextRef,
      excuteFilter,
      filterUpdate,
      cancleCheck,
      filterClose,
      tempFilter
    } = this.props;

    let examInfoArray =
      declareParam.getIn(['filter', 'examInfoArray']) && declareParam.getIn(['filter', 'examInfoArray']).toJS();

    let targetDivisionArray =
      declareParam.getIn(['filter', 'targetDivisionArray']) &&
      declareParam.getIn(['filter', 'targetDivisionArray']).toJS();

    let targetPositionArray =
      declareParam.getIn(['filter', 'targetPositionArray']) &&
      declareParam.getIn(['filter', 'targetPositionArray']).toJS();

    if (examInfoArray === undefined) {
      examInfoArray = [];
    }
    if (targetDivisionArray === undefined) {
      targetDivisionArray = [];
    }
    if (targetPositionArray === undefined) {
      targetPositionArray = [];
    }

    const isFiltered = !!declareParam.getIn(['filter', 'searchAll']);
    const sortOptions = [
      {
        text: defineMessages(formatMessage({ id: 'Target_3', defaultMessage: '등록순' })),
        value: 'targetNo'
      },
      {
        text: defineMessages(formatMessage({ id: 'Target_4', defaultMessage: '이름' })),
        value: 'targetName'
      },
      {
        text: defineMessages(formatMessage({ id: 'Target_5', defaultMessage: '이메일' })),
        value: 'targetEmail'
      },
      {
        text: defineMessages(formatMessage({ id: 'Target_6', defaultMessage: '소속' })),
        value: 'targetDivision'
      },
      {
        text: defineMessages(formatMessage({ id: 'Target_7', defaultMessage: '직급' })),
        value: 'targetPosition'
      }
    ];

    return (
      <div className={cx('declare-wrapper')}>
        <CtDeclareHeader />
        <div className={cx('target-subHeader')}>
          <Segment vertical>
            <Grid columns="equal" stackable>
              <Grid.Row textAlign="left">
                {currentPath === '/main/declaration/exam' &&
                  <DeclareExamFilter handleSelectOptions={handleSelectOptions} />
                }
                <Grid.Column className={cx('target-filter-area')} textAlign="right">
                  {/* 
                  <Tooltip
                    title={defineMessages(formatMessage({ id: 'Target_12', defaultMessage: '정렬 방법 선택' }))}
                    placement="top">
                    <div className={cx('dropdown-sort')}>
                      <div className={cx('dropdown-arrow-area')}>
                        <Image className={cx('dropdown-image')} src={'/img/target/list_select.png'} />
                      </div>
                      <Dropdown
                        className={cx('dropdown-targetSort')}
                        placeholder={defineMessages(formatMessage({ id: 'Target_3', defaultMessage: '등록순' }))}
                        floating
                        button
                        options={sortOptions}
                        onChange={onSortDeclare}
                      />
                    </div>
                  </Tooltip>
                  */}
                  <div className={cx('search-input-area')}>
                    <Input
                      size="mini"
                      placeholder={defineMessages(formatMessage({ id: 'Target_14', defaultMessage: '검색' }))}
                      onChange={this.onSearchChange}
                      onKeyPress={onSearchDeclare}
                      ref={searchTextRef}
                    />
                    <Button
                      id="bt-searchTarget"
                      fontColor="#757575"
                      size="mini"
                      icon={<img src="/img/exam/list_search.png" />}
                      onClick={onSearchDeclare}
                    />
                  </div>
                  <Tooltip
                    title={defineMessages(formatMessage({ id: 'Target_13', defaultMessage: '필터 해제' }))}
                    placement="top">
                    <IconButton className={cx('bt-filterCancel')} onClick={onFilterCancel}>
                      <Image src={'/img/table/btn_filter' + (isFiltered ? '_active' : '') + '.png'} />
                    </IconButton>
                  </Tooltip>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Segment>
        </div>
        <DeclareList
          declareOrdering={declareOrdering}
          tagDataByTagNo={tagDataByTagNo}
          declareDataByTargetNo={declareDataByTargetNo}
          selectDeclareTargetNo={selectDeclareTargetNo}
          handleSelectDeclare={handleSelectDeclare}
          declareScrollData={declareScrollData}
          onRefScroll={onRefScroll}
          page={page}
          totalPages={totalPages}
          onGetDeclare={onGetDeclare}
          onGetDeclareMail={onGetDeclareMail}
          isLoading={isLoading}
          filterUpdate={filterUpdate}
          currentPath={currentPath}
        />
      </div>
    );
  }
}

DeclareContent.propTypes = {
  handleSelectDeclare: PropTypes.func
};

export default injectIntl(DeclareContent);



// WEBPACK FOOTER //
// ./src/script/components/declare/DeclareContent.js